import { IconHeadHeart, IconLightBulb, IconLock, IconMedia, IconRadio } from "components/icons/Icons";
import React, { useEffect, useState } from "react";
import { arrayIncludes, isNullOrUndefOrEmpty, toDOMPurifyLazy } from "utils";

import { CaptionType } from "consts";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "micro-i18n";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/results/Caption.scss';

const Caption = ({ config, captionType, captionBody, translateBody = false }) => {
  const [captionBodyHtml, setCaptionBodyHtml] = useState(null);
  const potdUrl =
    config?.potdUrl || "https://pollsandinsights.com/connect/?utm_source=widget&utm_medium=caption&utm_campaign=potd";
  const { id: targetId } = config;
  const potdUrlWithTargetId = `${potdUrl}${potdUrl.includes("?") ? "&" : "?"}utm_id=target.${targetId}`;
  const potdUrlWithUtmContent = `${potdUrlWithTargetId}&utm_content=${captionBody}`;

  //componentDidUpdate() title
  useEffect(() => {
    if (captionBody) {
      //pass poll of the day url for variable substitution as it may be in a caption
      const bodyToPurify = translateBody ? i18n.t(captionBody, { potdUrl: potdUrlWithUtmContent }) : captionBody;

      !captionBodyHtml &&
        toDOMPurifyLazy(bodyToPurify, { ALLOWED_ATTR: ["href", "target"] }, true).then((purifiedCaptionBody) =>
          setCaptionBodyHtml({ __html: `${purifiedCaptionBody}` }),
        );
    }
  }, [captionBody, captionType, translateBody, potdUrlWithUtmContent]);

  const hasSupportedCaptionType = () => {
    return (
      captionType &&
      arrayIncludes(
        [
          CaptionType.Insight,
          CaptionType.Quiz,
          CaptionType.Trending,
          CaptionType.Privacy,
          CaptionType.Inspire,
          CaptionType.PollOfTheDay,
        ],
        captionType,
      )
    );
  };

  if (isNullOrUndefOrEmpty(captionBodyHtml)) {
    return null;
  }

  return (
    <div
      className={classNames("outline", {
        "csw-caption-inspire": captionType === CaptionType.Inspire,
        "csw-caption-privacy": captionType === CaptionType.Privacy,
        "csw-caption-potd": captionType === CaptionType.PollOfTheDay,
        "csw-caption":
          captionType !== CaptionType.Privacy &&
          captionType !== CaptionType.Inspire &&
          captionType !== CaptionType.PollOfTheDay,
      })}
      tabIndex="0"
    >
      {hasSupportedCaptionType() && (
        <div className="csw-caption-icon">
          {captionType === CaptionType.Insight && <IconRadio />}
          {captionType === CaptionType.Quiz && <IconHeadHeart />}
          {captionType === CaptionType.Trending && <IconMedia />}
          {captionType === CaptionType.Privacy && <IconLock />}
          {captionType === CaptionType.Inspire && <IconLightBulb />}
          {captionType === CaptionType.PollOfTheDay && <IconRadio />}
        </div>
      )}
      <div className="csw-caption-text">
        {hasSupportedCaptionType() && (
          <div className="csw-caption-title font-special">
            {captionType === CaptionType.Insight && i18n.t("CAPTION_TITLE_INSIGHT")}
            {captionType === CaptionType.Quiz && i18n.t("CAPTION_TITLE_QUIZ")}
            {captionType === CaptionType.Trending && i18n.t("CAPTION_TITLE_TRENDING")}
          </div>
        )}
        {captionBodyHtml && <div className="csw-caption-text-body" dangerouslySetInnerHTML={captionBodyHtml} />}
      </div>
    </div>
  );
};

Caption.propTypes /* remove-proptypes */ = {
  config: PropTypes.object,
  captionType: PropTypes.string,
  captionBody: PropTypes.string.isRequired,
  translateBody: PropTypes.bool,
};

export default Caption;
